import {injectable} from 'inversify';

import type {CoreClientDiaryEntriesListParams} from '../../../../../../api/types/core/methods';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {ListDiaryEntriesQuery} from '../ListDiaryEntries.query';

@injectable()
export class ListDiaryEntriesQueryJrpc implements ListDiaryEntriesQuery {
  async exec(
    props: ListDiaryEntriesQuery.Props = {},
  ): Promise<ListDiaryEntriesQuery.Response> {
    const params: CoreClientDiaryEntriesListParams = {
      expand: props.expand,
      limit: props.limit,
      offset: props.offset,
      query: props.query,
      sort: props.sort,
    };

    const {_items} = await apiRequest<CoreClientDiaryEntriesListParams>({
      method: 'client.diary_entries.list',
      params,
    });

    return _items;
  }
}
